import { isDev } from 'utils';

export const isNotEmptyObj = obj =>
  Object.keys(obj).length > 0 && obj.constructor === Object;

export const zipCodeRegex = /^\d{5}$|^\d{5}-\d{4}$/;

export const textOnlyRegex = /^[A-Za-z ]{2,}$/;

export const textOnlyRegexNoMandatory = /^[A-Za-z ]*$/;

export const addressRegex = /^[a-zA-Z0-9\s,.'-]{3,}$/;

export const addressRegexNoMandatory = /^[a-zA-Z0-9\s,.'-]*$/;

export const numbersOnly = /^\d+$/;

export const checkTextOnly = text => textOnlyRegex.test(text);

export const checkNumbersOnly = text => numbersOnly.test(text);

export const getLastThreeDigits = number => number.slice(number.length - 3);

export const checkRoutingNumber = n => {
  let isValid = false;
  if (checkNumbersOnly(n)) {
    n = n ? n.match(/\d/g).join('') : 0; //get just digits
    let c = 0;

    if (n && n.length === 9) {
      //don't waste energy totalling if its not 9 digits
      for (var i = 0; i < n.length; i += 3) {
        //total the sums
        c +=
          parseInt(n.charAt(i), 10) * 3 +
          parseInt(n.charAt(i + 1), 10) * 7 +
          parseInt(n.charAt(i + 2), 10);
      }
      isValid = c !== 0 && c % 10 === 0; //check if multiple of 10
    }
  }
  return isValid;
};

export const checkTextOnlyNoMandatory = text =>
  textOnlyRegexNoMandatory.test(text);

export const checkValidAddress = address => addressRegex.test(address);

export const checkValidAddressNoMandatory = address =>
  addressRegexNoMandatory.test(address);

export const checkValidZipCode = zipCode => zipCodeRegex.test(zipCode);

export const loginPathName = isDev ? '/login' : '/';

export const rolesPathName = isDev ? '/login' : '/apps/platform-admin/#/roles';

export const forbiddenPathName = isDev
  ? '/#/forbidden'
  : '/apps/billing/#/forbidden';

export const invoicesDisplayed = 4;

export const redirectToLogin = () => {
  window.location.replace(loginPathName);
};

export const redirectToForbidden = () => {
  window.location.replace(forbiddenPathName);
};

export const redirectToRolesAndPermissions = () => {
  window.location.replace(rolesPathName);
};

export const cardType = cardType => {
  switch (cardType) {
    case 'DI':
      return 'DISCOVER';
    case 'VI':
      return 'VI';
    case 'AX':
      return 'AMERICAN_EXPRESS';
    case 'MC':
      return 'MC';
    default:
      return '';
  }
};

export const formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
});

const delayTimer = {
  timer: null,
};

export const doSearchDelayed = callback => {
  clearTimeout(delayTimer.timer);
  delayTimer.timer = setTimeout(() => callback(), 700);
};

export const isAdmin = roles =>
  !!roles.find(role => role.roleType === 'SUPER_ADMIN');

export const checkBillingPermission = permissions =>
  !!permissions.find(
    permission => permission.resource === 'update_company_profile'
  );

export const paymentOptions = {
  CREDIT_CARD: 'CREDIT_CARD',
  ECHECK: 'ECHECK',
};
